import React from 'react';
import { redirect } from 'react-router';

import ExternalSubmission from './ExternalSubmission';
import Feedbacks from './FeedbackCenter/FeedbackDashboard/FeedbackTab/Feedbacks/Feedbacks';
import { Layout } from './Layout';

/* istanbul ignore next */
export const routesConfig = [
	{
		path: '/proxy/feedback',
		element: <Layout />,
		children: [
			{
				path: 'dashboard',
				children: [
					{
						index: true,
						lazy: () => import('./FeedbackCenter/FeedbackDashboard/Dashboard/Dashboard'),
					},
					{
						// this route is for dashboard feedback page
						path: 'feedback/:feedbackRequestId',
						lazy: () =>
							import(
								'./FeedbackCenter/FeedbackDashboard/Dashboard/DashboardFeedback/DashboardFeedbackForm'
							),
					},
					{
						path: 'workflow',
						element: <Feedbacks />,
					},
					{
						// this route is for feedback tab feedback page
						path: 'workflow/feedback/:feedbackRequestId',
						lazy: () =>
							import(
								'./FeedbackCenter/FeedbackDashboard/FeedbackTab/FeedbackDetails/FeedbackDetails'
							),
					},
					{
						path: 'workflow/feedback/summary/:submittalId',
						lazy: () => import('./FeedbackCenter/DetailedFeedbackSummary/DetailedFeedbackSummary'),
					},
				],
			},
			{
				path: 'request',
				lazy: () => import('./FeedbackCenter/AssignFeedback/AssignFeedback'),
			},
			{
				path: 'feedback-spa/export',
				children: [
					{
						path: '',
						loader: ({ request }) => {
							const url = new URL(request.url);
							return redirect(`/proxy/feedback/dashboard/workflow?${url.searchParams.toString()}`);
						},
					},
					{
						path: 'feedback/:feedbackRequestId',
						loader: ({ params, request }) => {
							const url = new URL(request.url);
							return redirect(
								`/proxy/feedback/dashboard/workflow/feedback/${params.feedbackRequestId}?${url.searchParams.toString()}`,
							);
						},
					},
					{
						path: 'assign',
						loader: ({ request }) => {
							const url = new URL(request.url);
							return redirect(`/proxy/feedback/request?${url.searchParams.toString()}`);
						},
					},
				],
			},
			{
				path: 'settings',
				children: [
					{
						path: '',
						loader: () => redirect(`/proxy/feedback/settings/home/forms`),
					},
					{
						path: 'home/:tab',
						lazy: () => import('./FormBuilder/Home'),
					},
					{
						path: 'createForm',
						lazy: () => import('./FormBuilder/CreateForm'),
					},
					{
						path: 'form/:id',
						lazy: () => import('./FormBuilder/FormDetail'),
					},
					{
						path: 'editForm',
						lazy: () => import('./FormBuilder/EditForm'),
					},
					{
						path: 'createQuestion',
						lazy: () => import('./FormBuilder/CreateQuestion'),
					},
					{
						path: 'question/:id',
						lazy: () => import('./FormBuilder/QuestionDetail'),
					},
					{
						path: 'editQuestion',
						lazy: () => import('./FormBuilder/EditQuestion'),
					},
				],
			},
		],
	},
	{
		path: 'external-submission',
		element: <ExternalSubmission />,
	},
];
